import { Component, OnInit } from '@angular/core';
import { MainPageService } from '../../main-page.service';
import { SystemModel } from '../../../models/dictionaries/system.model';

declare var $: any;


@Component({
  selector: 'app-systems-grid',
  template: `<!-- Create Modal -->
<div class="modal" id="addSystemModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="templateSystem.name" #ctrl="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="templateSystem.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl.invalid" (click)="saveNewSystem()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Edit Modal -->
<div class="modal" id="editModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <div class="display-flex">
                    <span class="modal-label">Name:</span>
                    <input type="text" [(ngModel)]="editedSystem.name" #ctrl2="ngModel" required>
                </div>
                <div class="display-flex">
                    <span class="modal-label">Description:</span>
                    <input type="text" [(ngModel)]="editedSystem.description">
                </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="ctrl2.invalid" (click)="editSystem()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="deleteModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this system?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="deleteSystem(editedSystem)">Delete</button>
            </div>
        </div>
    </div>
</div>


<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addSystemModal">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let system of systemsGridData, let row_no = index">
        <td>{{system.name}}</td>
        <td>{{system.description}}</td>
        <td class="columnWithIcons">
            <button type="button" class="btn editBtn" data-toggle="modal" data-target="#editModal" (click)="setChoosenElement(system, row_no)">
                <i class="fa fa-edit"></i>
            </button>
            <button type="button" class="btn deleteBtn" data-toggle="modal" data-target="#deleteModal" (click)="setChoosenElement(system, row_no)">
                <i class="fa fa-trash"></i>
            </button>
        </td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:110px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}`]
})
export class SystemsGridComponent implements OnInit {
  isSystemsHidden = true;
  systemsGridData: SystemModel[];
  templateSystem = new SystemModel();
  editedSystem = new SystemModel();
  rowNumber: number;
  headers: string[] = ['Name', 'Description', ''];

  constructor(private mainPageService: MainPageService) {}

  public ngOnInit(): void {
    this.loadGridDataFromDb();
    this.mainPageService.deleteSystemSubject.subscribe( (value) => {
      this.systemsGridData = this.systemsGridData.filter(x => x._id !== value);
    });
  }

  loadGridDataFromDb() {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsGridData = response.sort(function (a, b) {
        return (a.name < b.name) ? -1 : 1;
      });
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
        $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isSystemsHidden = !this.isSystemsHidden;
  }

  saveNewSystem() {
    this.mainPageService.addNewSystemIntoDb(JSON.stringify(this.templateSystem)).subscribe((response) => {
      this.templateSystem._id = response;
      this.systemsGridData.push(this.templateSystem);
      this.templateSystem = new SystemModel();
    });
  }

  setChoosenElement(element, row) {
    this.editedSystem = {
      ...element,
    };
    this.rowNumber = row;
  }

  editSystem() {
    console.log(this.systemsGridData[this.rowNumber]);
    Object.assign(this.systemsGridData[this.rowNumber], this.editedSystem);
    this.mainPageService.updateSystemInDb(JSON.stringify(this.editedSystem)).subscribe(() => { });
  }

  deleteSystem(element) {
    this.mainPageService.removeSystem(element._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteSystemSubject.next(element._id);
  }
}
